
import { defineComponent, PropType } from 'vue'
import { meeting_title } from '@/utils/constant'
import { IFlowChar } from '@/typings/home'

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<IFlowChar>
    }
  },
  setup() {
    return {
      meeting_title
    }
  }
})
